<template>
  <div class="container-card">
    <div>
      <img class="logo-otp" src="/assets/images/logos/logo-zd-email.png" alt="logo" />
      <p class="title-otp">
        Ingresa el código de 6 dígitos<br />
        que te enviamos a <span class="email-otp">{{ maskedEmail }}</span>.
      </p>

      <div class="otp-container">
        <input
          :disabled="!cookie"
          v-for="(digit, index) in 6"
          :key="index"
          type="number"
          maxlength="1"
          ref="otpRefs"
          class="bg-transparent otp-input"
          @input="handleInput($event, index)"
          @keydown.backspace="handleBackspace($event, index)"
          @paste="handlePaste"
        />
      </div>

      <div class="container-btn">
        <button class="btn-resend" :disabled="isResendDisabled || !cookie" @click="resendCode">
          Reenviar código
          <span v-if="isResendDisabled">({{ formattedTime }})</span>
        </button>

        <button class="btn-back-otp" @click="goBack">
          Regresar
        </button>
      </div>
    </div>

    <div class="footer-otp">
      © {{ new Date().getFullYear() }} Zona Digital
    </div>
  </div>

  <!-- Overlay de animación como en el primero -->
  <div v-if="showSuccessAnimation" class="animation-overlay">
    <video src="/auht.webm" autoplay muted playsinline width="250"></video>
  </div>
</template>

<script>
import myApi from '../../../plugins/axios'
import { getCurrentInstance, ref } from 'vue'

export default {
  name: 'CodeOtp',
  data() {
    return {
      cookie: null,
      loading: false,
      isResendDisabled: false,
      timer: 0,
      intervalId: null,
      showSuccessAnimation: false
    }
  },
  computed: {
    maskedEmail() {
      if (!this.cookie || !this.cookie.email) return '';
      return this.cookie.email.replace(/(.{2}).+(.{2}@.+)/, "$1******$2");
    },
    formattedTime() {
      const minutes = Math.floor(this.timer / 60)
      const seconds = this.timer % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }
  },
  setup() {
    const otpRefs = ref([])
    const { proxy } = getCurrentInstance()

    const handleInput = (e, index) => {
      e.target.value = e.target.value.slice(0, 1);
      const value = e.target.value
      if (value && index < otpRefs.value.length - 1) {
        otpRefs.value[index + 1].focus()
      }
      if (otpRefs.value.every(input => input.value.length === 1)) {
        const enteredOtp = otpRefs.value.map(i => i.value).join('')
        proxy.verifiedCode(enteredOtp)
      }
    }

    const handleBackspace = (e, index) => {
      if (!e.target.value && index > 0) {
        otpRefs.value[index - 1].focus()
      }
    }
    
    const handlePaste = (e) => {
      e.preventDefault()
      let pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
      const inputs = otpRefs.value
      pastedData.split('').forEach((char, index) => {
        if (inputs[index]) {
          inputs[index].value = char
        }
      })
      const nextIndex = Math.min(pastedData.length, inputs.length - 1)
      if (inputs[nextIndex]) inputs[nextIndex].focus()
      if ([...inputs].every(input => input.value.length === 1)) {
        const enteredOtp = [...inputs].map(i => i.value).join('')
        proxy.verifiedCode(enteredOtp)
      }
    }

    return {
      otpRefs,
      handleInput,
      handleBackspace,
      handlePaste
    }
  },
  methods: {
    goBack() {
      this.$router.push('/login')
    },
    // Método para ir a la página de inicio (queda disponible aunque no lo mostremos en UI)
    goToHome() {
      this.$router.push({ path: '/' }); 
    },
    async verifiedCode(code) {
      if (!code || code.length !== 6) {
        this.$notify({ title: "Código Incompleto", text: "El código debe tener 6 dígitos.", type: 'error' });
        return;
      }
      this.loading = true;
      try {
        const resp = await myApi.post("ecommerce/verified_code/", null, {
            params: {
              email: this.cookie.email,
              code: code,
            }
        });
        
        const newResetTicket = resp.data.reset_ticket;

        if (!newResetTicket) {
            this.loading = false;
            this.$notify({ title: "Error de Respuesta", text: "No se recibió el ticket de reseteo.", type:'error' });
            return;
        }

        this.loading = false;
        
        this.$cookies.set("code_password", { email: this.cookie.email, ticket: newResetTicket }, "15MIN");
        
        this.showSuccessAnimation = true;
        setTimeout(() => {
          this.$router.push({ name: 'ResetPassword' });
        }, 6000);

      } catch (error) {
        this.loading = false;
        const errorMessage = error.response?.data?.message_text || "El código es incorrecto o ha expirado.";
        this.$notify({ title: "Error de Verificación", text: errorMessage, type:'error' });
        this.$refs.otpRefs.forEach(input => input.value = '');
        if (this.$refs.otpRefs[0]) this.$refs.otpRefs[0].focus();
      }
    },
    async resendCode() {
      try {
        if (!this.cookie || !this.cookie.email) return;
        await myApi.post('ecommerce/forgot_password', null, { params: { email: this.cookie.email } });
        
        this.$notify({ title: "Código Reenviado", text: 'Se ha enviado un nuevo código.', type: 'success' });
        this.startTimer(600); // 10 minutos
        
        const expireTime = new Date();
        expireTime.setSeconds(expireTime.getSeconds() + 600);
        localStorage.setItem(`resendExpire_${this.cookie.email}`, expireTime.toISOString());
        
      } catch (error) {
        this.$notify({ title: "Error", text: 'No se pudo reenviar el código.', type: 'error' });
      }
    },
    startTimer(duration) {
      this.isResendDisabled = true;
      this.timer = duration;
      if (this.intervalId) clearInterval(this.intervalId);
      
      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.intervalId);
          this.isResendDisabled = false;
          localStorage.removeItem(`resendExpire_${this.cookie.email}`);
        }
      }, 1000);
    }
  },
  created() {
    this.cookie = this.$cookies.get("forgot_password") || null;
    if(!this.cookie){
      this.$router.push({ name: 'ForgotPassword' });
      return;
    }
    
    const resendExpire = localStorage.getItem(`resendExpire_${this.cookie.email}`);
    if (resendExpire) {
      const remaining = Math.floor((new Date(resendExpire) - new Date()) / 1000);
      if (remaining > 0) {
        this.startTimer(remaining);
      } else {
        localStorage.removeItem(`resendExpire_${this.cookie.email}`);
      }
    }
  },
  beforeUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}
</script>

<style scoped>
/* === Estilo y formato del primer componente aplicados aquí === */




/* Overlay de éxito igual al primero */
.animation-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Responsivo */
@media (min-width: 768px) {
  .title-otp {
    font-size: 1.25rem;
  }
  .otp-input {
    width: 54px;
    height: 62px;
    font-size: 1.8rem;
  }
}
</style>
